import {
  Checkbox,
  FormControl,
  ListItemText,
  MenuItem,
  Select,
} from '@mui/material';
import React from 'react';

interface MultiSelectCheckboxProps {
  options: string[];
  selectedValues: string[];
  onSelectionChange: (selectedValues: string[]) => void;
  placeholder?: string;
  size?: 'small' | 'medium';
  minWidth?: string;
}

const MultiSelectCheckbox: React.FC<MultiSelectCheckboxProps> = ({
  options,
  selectedValues,
  onSelectionChange,
  placeholder = 'Seleccionar opciones',
  size = 'small',
  minWidth = '200px',
}) => {
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const handleChange = (event: any) => {
    const {
      target: { value },
    } = event;
    onSelectionChange(typeof value === 'string' ? value.split(',') : value);
  };

  const renderValue = (selected: any) => {
    return selected.length > 0
      ? `${selected.length} ${selected.length === 1 ? 'mes' : 'meses'}`
      : placeholder;
  };

  return (
    <div style={{ width: '100%' }}>
      <FormControl size={size} style={{ width: '100%' }}>
        <Select
          multiple
          value={selectedValues}
          onChange={handleChange}
          renderValue={renderValue}
          MenuProps={MenuProps}
          style={{ width: '100%' }}
        >
          {options.map((option) => (
            <MenuItem key={option} value={option}>
              <Checkbox checked={selectedValues.includes(option)} />
              <ListItemText primary={option} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default MultiSelectCheckbox;
